import './stack.css';
import Drupal from '../Assets/drupal.jpg';
import R from  '../Assets/react1.png';
import F from '../Assets/flutter1.png';
import W from '../Assets/wordpress1.png';
import RN from '../Assets/ReactNative.png';
import N from '../Assets/nodejs.jpg';
import React from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';


  function FormRow() {
    return (
      <React.Fragment>
        <Grid item xs={12} sm={6} md={4} >
              <Card sx={{ maxWidth: 345 }} >
      <CardMedia
        component="img"
        height="140"
        width="100%"
        src={Drupal}
        alt="green iguana"
      />
      <CardContent>
        <Typography gutterBottom variant="h5" component="div">
         <strong> <a href='https://www.drupal.org/' target="_blank"> Drupal </a> </strong>
        </Typography>
      </CardContent>
    </Card>
        </Grid>
        <Grid item xs={12} sm={6} md={4} >
              <Card sx={{ maxWidth: 345 }} >
      <CardMedia
        component="img"
        width="100%"
        height="140"
        src={R}
        alt="green iguana"
      />
      <CardContent>
        <Typography gutterBottom variant="h5" component="div">
         <strong> <a href="https://reactjs.org/" target="_blank"> React </a></strong> 
        </Typography>
      </CardContent>
    </Card>
        </Grid>
        <Grid item xs={12} sm={6} md={4} >
              <Card sx={{ maxWidth: 345 }} >
      <CardMedia
        component="img"
        height="140"
        width="100%"
        src={F}
        alt="green iguana"
      />
      <CardContent>
        <Typography gutterBottom variant="h5" component="div">
          <strong> <a href="https://flutter.dev/" target="_blank"> Flutter </a></strong>
        </Typography>
      </CardContent>
    </Card>
    </Grid>
    <Grid item xs={12} sm={6} md={4} >
              <Card sx={{ maxWidth: 345 }} >
      <CardMedia
        component="img"
        height="140"
        width="90%"
        src={RN}
        alt="react native"
      />
      <CardContent>
        <Typography gutterBottom variant="h5" component="div">
          <strong> <a href="https://reactnative.dev/" target="_blank"> React Native </a></strong>
        </Typography>
      </CardContent>
    </Card>
    </Grid>
    <Grid item xs={12} sm={6} md={4} >
              <Card sx={{ maxWidth: 345 }} >
      <CardMedia
        component="img"
        height="140"
        width="100%"
        src={N}
        alt="NodeJs"
      />
      <CardContent>
        <Typography gutterBottom variant="h5" component="div">
          <strong> <a href="https://nodejs.org/en/" target="_blank"> NodeJs </a></strong>
        </Typography>
      </CardContent>
    </Card>
    </Grid>
    <Grid item xs={12} sm={6} md={4} >
              <Card sx={{ maxWidth: 345 }} >
      <CardMedia
        component="img"
        height="140"
        width="100%"
        src={W}
        alt="wordpress"
      />
      <CardContent>
        <Typography gutterBottom variant="h5" component="div">
          <strong> <a href="https://wordpress.com/" target="_blank"> Wordpress </a></strong>
        </Typography>
      </CardContent>
    </Card>
    </Grid>
      </React.Fragment>
    );
  }

  
export default function Stack() {
    return (
        <div className='stack-grid'>
    <Box sx={{ flexGrow: 1 }}>
      <Grid container spacing={1}>
        <Grid container item spacing={3}>
          <FormRow />
        </Grid>
      </Grid>
    </Box>
        </div>
    );
}